import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { Validators, FormControl } from "@angular/forms";
import * as XLSX from 'xlsx';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { PayoutService } from 'src/app/services/payout.service';
const swal = require('sweetalert');
import * as uuid from 'uuid';
import { Router, ActivatedRoute } from "@angular/router";
@Component({
  selector: 'app-managepayout-beneficiary',
  templateUrl: './managepayout-beneficiary.component.html',
  styleUrls: ['./managepayout-beneficiary.component.scss']
})
export class ManagepayoutBeneficiaryComponent implements OnInit {
  rowdata:any=[];
  BeneficiaryName= new FormControl("", []);
 editbenificiary: boolean = false;
 deletebenificiary: boolean = false;
 verifystatus: boolean = false;
  AccountNo= new FormControl("", [Validators.required]);
  PayOutBeneficiaryKeyId= new FormControl("", [Validators.required]);
  BankName= new FormControl("", [Validators.required]);
  PayOutCustomerKeyId= new FormControl("", [Validators.required]);
  filtering: boolean = false;
  MerchantKeyId:any;
  loggedinuseremail:any;
  editing = {};
  rows=[];
  row=[];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  rowsSel = [];
  Tourtransaction:any;
  getinfo:any;
  excelTranStatus: any;
  excelTansactionDataResponse = [];
  symbol = [
    { text: "=", value: "=" },
    { text: "<", value: "<" },
    { text: ">", value: ">" },
    { text: "<=", value: "<=" },
    { text: ">=", value: ">=" },
    { text: "<>", value: "<>" },

  ];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  amountcheck= new FormControl("", [Validators.required]);
  AccountNumber= new FormControl("", [Validators.required]);
  TransactionId= new FormControl("", [Validators.required]);
  Amount= new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  isreportsbtnActive: boolean = false;
  fromdate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  constructor(private commonfunction: CommonFunctionService, private service: PayoutService,private transactionservice: TransactionService,private router:Router) { }

  ngOnInit() {

    this.getpayoutBeneficiary();
    this.getUserPermissions();
  }
  getpayoutBeneficiary()
  {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;



  
  let form = {
      
    MerchantKeyId: 0,
    PayOutBeneficiaryKeyId: "",
    PayoutCustomerkeyId: "",
    BankCodeType: "",
    BankName: "",
    BranchName: "",
    BankCode: "",
    AccountNumber: "",
    BankAccountType: "",
    BankCountry: "",
    VerificationStatus: "",
    VerificationResponse: "",
    UpiVpa: "",
    PreferPayOutAccount: "",
    UpdatedUserName: "",
    BeneficiaryName:"",

  };
    this.payoutBeneficiary((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.row = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);


      // this.row.forEach(element => {
      //   if (element.AccountNumber !=null) {
      //   var first6digits = element.AccountNumber.slice(0, 6);
      //  var last4digits = element.AccountNumber.slice(-4);
      //     element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      //   }
       
      // });

    });
  }

  filters() {
    this.filtering = !this.filtering;
  }
  payoutBeneficiary(cb) {

    const req = new XMLHttpRequest();

    this.service.GetPayOutConatctBeneficiariesList(this.MerchantKeyId).subscribe(data => {
{

    if(data !=null)
    {
      this.temp = _clone(data);
      this.row = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);


      this.row.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
       
      });
    }
  }
});
    // req.open('GET', environment.GetPayOutConatctBeneficiariesList + "?MerchantKeyId=" + this.MerchantKeyId);
   
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
  }
  checkRangeType()
  {
    var daterange=this.daterange.value;
    if(daterange=="Custom Date Range")
    {
     this.isCustomDateSelected = true;
     this.isStartDateGreaterthenEndDate = false;
        this.Rfromdate=true;
       this. Dfiltering=false;
       this.fromdate.setValue('');
       this.todate.setValue('');
       this.isreportsbtnActive = false;
    }
    else{
     this.isCustomDateSelected = false;
     this.isStartDateGreaterthenEndDate = false;
     this.Rfromdate=false;   
    }
  }
  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
       this.search();

    }
  }

  search() {
    this.GetPayOutcontactfilter((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.row = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);
      // this.row.forEach(element => {
      //   if (element.AccountNumber !=null) {
      //   var first6digits = element.AccountNumber.slice(0, 6);
      //  var last4digits = element.AccountNumber.slice(-4);
      //     element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      //   }
       
      // });
    });
 
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }
      
  viewbeneficiarydetails(pcid:any,mid:any){
    this.service.ViewPayOutBeneficiarieList(mid, pcid).subscribe(result => {
      this.rowdata = result[0];
      if(result[0].BankCodeType==0)
      {
        result[0].BankCodeType="RoutingTransitNumber"
      }
      else if(result[0].BankCodeType==1)
      {
        result[0].BankCodeType="BankSortCodes"
      }
      else if(result[0].BankCodeType==2)
      {
        result[0].BankCodeType="BsbNumbers"
      }
      else if(result[0].BankCodeType==3)
      {
        result[0].BankCodeType="SwiftCode"
      }
      else if(result[0].BankCodeType==4)
      {
        result[0].BankCodeType="MicrCode"
      }
      else if(result[0].BankCodeType==5)
      {
        result[0].BankCodeType="IfscCode"
      }
      if(result[0].BankAccountType==0)
      {
        result[0].BankAccountType="SalaryAccount"
      }
      else if(result[0].BankAccountType==1)
      {
        result[0].BankAccountType="CurrentAccount"
      }
      else if(result[0].BankAccountType==2)
      {
        result[0].BankAccountType="SavingAccount"
      }
      else if(result[0].BankAccountType==3)
      {
        result[0].BankAccountType="RecurringDeposits"
      }
      else if(result[0].BankAccountType==4)
      {
        result[0].BankAccountType="FixedDeposits"
      }
    if(result[0].BankAccountType==0)
            {
              result[0].BankAccountType="SalaryAccount"
            }
            else if(result[0].BankAccountType==1)
            {
              result[0].BankAccountType="CurrentAccount"
            }
            else if(result[0].BankAccountType==2)
            {
              result[0].BankAccountType="SavingAccount"
            }
            else if(result[0].BankAccountType==3)
            {
              result[0].BankAccountType="RecurringDeposits"
            }
            else if(result[0].BankAccountType==4)
            {
              result[0].BankAccountType="FixedDeposits"
            }
    });

  }
  GetPayOutcontactfilter(cb) {
    var daterange = this.daterange.value;
    var pid = this.PayOutBeneficiaryKeyId.value;
    var AccountNumber = this.AccountNo.value;
    var Name = this.BankName.value;
    var customerkeyid=this.PayOutCustomerKeyId.value;
    var benificaryname=this.BeneficiaryName.value;

    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = '01/01/1990';
      // this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }

    const req = new XMLHttpRequest();
    this.service.viewbenficiarieFilterdataurl(this.MerchantKeyId,this.Fromdate1,this.todate1,AccountNumber,pid,Name,customerkeyid,benificaryname).subscribe(data => {
      if(data !=null)
      {
        this.temp = _clone(data);
        this.row = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
        this.row.forEach(element => {
          if (element.AccountNumber !=null) {
          var first6digits = element.AccountNumber.slice(0, 6);
         var last4digits = element.AccountNumber.slice(-4);
            element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
          }
         
        });
      }

  });
    // req.open('GET',
    //   environment.viewbenficiarieFilterdataurl + "?MerchantKeyId=" + this.MerchantKeyId  + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&AccountNumber=" + AccountNumber + "&PayOutBeneficiaryKeyId=" + pid +"&BankName=" +Name +"&CustomerkeyId=" +customerkeyid);
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
  }



  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }

  readAndExportToExcelData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.row.length > 0) {
      this.row.forEach(element => {
        if (element.Status == 1) {
          this.excelTranStatus = 'Verify Beneficiary';
        }
        else if (element.Status == 2) {
          this.excelTranStatus = 'Verified';
        }
        else{
          this.excelTranStatus =''
        }
        var manageTranArray = { 'Status check':this.excelTranStatus,'PayoutCustomerkeyId': element.PayoutCustomerkeyId, 'PayOutBeneficiaryKeyId': element.PayOutBeneficiaryKeyId,
         'AccountNumber': element.AccountNumber, 'BeneficiaryName':element.BeneficiaryName,'BankName': element.BankName, 'BranchName': element.BranchName, 'UpdatedDatetime': element.UpdatedDatetime}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
         { header: ['Status check','PayoutCustomerkeyId', 'PayOutBeneficiaryKeyId', 'AccountNumber','BeneficiaryName', 'BankName', 'BranchName', 'UpdatedDatetime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageBeneficiary_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }

  verificationbenficiarie(bid)
  {
    this.row.forEach(element => {
      if (element.PayOutBeneficiaryKeyId == bid) {
       
        let form = {
          MerchantKeyId: 0,
          UniqueRequestId: "",
          PayOutType: "",
          PayOutDate: "",
          TransactionType: "",
          PaymentType: "",
          Amount: 0,
          PayOutBeneficiaryKeyId: "",
          PayoutCustomerkeyId: "",
          LoginUserId:''
        }
        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
        form.MerchantKeyId = merchantdata.MerchantKeyId;
        const myId = uuid.v4();
        var uniqueid=myId.substring(0,9);
       form.MerchantKeyId= merchantdata.MerchantKeyId;
       form.UniqueRequestId= uniqueid;
       form.PayOutType= "Immediate";
       form.PayOutDate=  new Date().toString();
       form.TransactionType= "Debit";
       form.Amount= 1;
       form.PaymentType= "IMPS";
        form.PayOutBeneficiaryKeyId= bid;
        form.PayoutCustomerkeyId= element.PayoutCustomerkeyId;
        form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
       this.service.VerifyBeneficiary(form).subscribe(result => {
        
        if(result.ResponseCode==1)
        {
          swal("Verified", "Verified beneficiary", "success");
          this.router.navigate(["PayOut/PayOutTransactions"]);
        }
        else
        {
          swal("Pending", result.ResponseText, "warning");
          // this.router.navigate(["PayOut/PayOutTransactions"]);
        }
      });
      }
    });
  }




  getUserPermissions() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
      if (result != null) {
        for (var i in result) {
          if (result[i].UserPermission == 'PayOut') {
            var type = result[i].Type;
            if (type == 'R') 
            {
                
                this.editbenificiary=false;
                this.deletebenificiary=false;
                this.verifystatus=false;
               
            }
           else if (type == 'RW') 
            {
              this.editbenificiary=true;
              this.deletebenificiary=true;
              if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
              {
              this.verifystatus=true;
              }
              else{
                this.verifystatus=false;
              }
            }
           else if (type == 'RWD') 
            {
              this.editbenificiary=true;
              this.deletebenificiary=true;
              if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
              {
              this.verifystatus=true;
              }
              else{
                this.verifystatus=false;
              }
              
            }
          }
        }
  
      }
  
    });
  }

  resetForm(){

    this.daterange.reset(''); 
    this.PayOutBeneficiaryKeyId.reset(''); 
    this.PayOutCustomerKeyId.reset('');
    this.AccountNo.reset('');
    this.BankName.reset('');
    this.BeneficiaryName.reset('');
    this.row=[];
    
  
  }
}
